import { inLicenseFormDetailsByPID } from "@redux/reducers/inLicensedReducer";

export enum ActionType {
  INLICENSED_DETAIL_BY_PID = "INLICENSED_DETAIL_BY_PID",
}
export interface IInLicensedByPid {
  type: ActionType.INLICENSED_DETAIL_BY_PID;
  payload: inLicenseFormDetailsByPID[];
}

export type Action = IInLicensedByPid;
